export enum AnimatedHeightType {
  Auto = 'auto',
}
